<template>
  <div class="login">
    <div class="login_info">
      <div class="login_info_header">
        <img class="tianji" src="//img.yimutian.com/crm/5bcc311164008157d949718e7723c378.png">
        农业大数据系统
      </div>
      <form class="innput_zone" @submit.prevent='login(phoneNum, smsCode)'>
        <div class="title">登录一亩田</div>
        <div class="flex input_row">
          <input v-model.trim='phoneNum' maxlength="11" class="phone_input flex1" type="text" placeholder="请输入手机号">
        </div>
        <div class="flex input_row">
          <input v-model.trim='picCode' maxlength="4" class="phone_input flex1" type="text" placeholder="图形验证码">
          <img class="img_code" @click="getCaptcha" v-if="codeStr" :src="codeStr | getImgUrl" />
        </div>
        <div class="flex input_row">
          <input v-model.trim='smsCode' maxlength="4" class="phone_input flex1" type="number" placeholder="手机验证码">
          <button class="sendsms_btn" @click='sendsms(phoneNum)' type="button">{{sendsmsBtn}}</button>
        </div>
        <div>
          <button class="ok_btn" type="submit">登录</button>
        </div>
        <div
          style="display: flex; align-items: center; font-size: 14px; color: #666; margin-top: -6px; margin-bottom: 6px;"
        >
          <div v-if="xieyiCheck" @click="onXieyiCheck" style="width: 12px; height: 12px; border: 1px solid #005582; border-radius: 50%;">
            <div style="width: 8px; height: 8px; background: #005582; border-radius: 50%; margin: 1px"></div>
          </div>
          <div v-else @click="onXieyiCheck" style="width: 12px; height: 12px; border: 1px solid #666; border-radius: 50%;"></div>
          <label @click="onXieyiCheck" style="padding-left: 4px;">请阅读并同意</label>
          <a target="_blank" style="font-size: 14px; text-decoration: none; color: #005582" href="https://cms.ymt.com/page/page/show?id=655">《用户协议/隐私政策》</a>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { http, helper } from '@/http'
import config from '@/config'
import { mapState } from 'vuex'

let sendSmsTimer

export default {
  data () {
    return {
      xieyiCheck: false,
      codeStr: '',
      picCode: '',
      sendsmsBtn: '发送验证码',
      phoneNum: '',
      smsCode: '',
      winHeight: '100%'
    }
  },
  filters: {
    getImgUrl (codeStr) {
      return config.baseUrl + '/captcha/api/genimage?code_str=' + encodeURIComponent(codeStr)
    }
  },
  computed: {
    ...mapState({
      userName: state => state.user.userName,
      loginStatus: state => state.user.loginStatus
    })
  },
  created () {
    this.getCaptcha()
  },
  methods: {
    onXieyiCheck () {
      this.xieyiCheck = !this.xieyiCheck
    },
    getCaptcha () {
      this.codeStr = ''
      http.get('/captcha/api/getcodestr.json').then(({ data }) => {
        if (data.status === 0) {
          this.codeStr = data.code_str
        }
      })
    },
    sendsms (num) {
      if (sendSmsTimer) return
      if (!num || !/\d{11}/.test(num)) {
        alert('请输入正确的手机号码')
        return
      }
      if (!this.picCode) {
        alert('请输入图形验证码')
        return
      }
      let timeLeft = 60
      http.post('/uc/login/phoneverify/websendsms.json', {
        code_str: this.codeStr,
        captcha: this.picCode,
        mobile: num
      }).then(({ data }) => {
        if (data.status === 0) {
          sendSmsTimer = setInterval(() => {
            timeLeft--
            if (timeLeft > 0) {
              this.sendsmsBtn = '剩余' + timeLeft + '秒'
            } else {
              this.sendsmsBtn = '获取验证码'
              clearInterval(sendSmsTimer)
              sendSmsTimer = undefined
            }
          }, 1000)
          this.sendsmsBtn = '剩余' + timeLeft + '秒'
        } else {
          alert(data.errmsg || '发送失败')
        }
      })
    },
    login (phoneNum, vcode) {
      if (!this.xieyiCheck) {
        alert('请阅读并同意《用户协议/隐私政策》')
        return
      }
      if (!phoneNum || phoneNum.length !== 11) {
        alert('请输入11位手机号')
        return
      }
      if (!vcode || vcode.length !== 4) {
        alert('请输入4位验证码')
        return
      }
      http.post(`/uc/login/phoneverify/webverifysms.json`, {
        mobile: this.phoneNum,
        vcode
      }).then(({ data }) => {
        if (data.status === 0 && data.sid) {
          helper.setSid(data.sid)
          this.$store.commit('user/setUsername', data.nickname)
          this.$store.commit('user/setLoginStatus', 1)
          http.get(`/canmou/tianji/product/is_vip?location_id=20`, {}).then(response => {
            if (response.data.status === 0) {
              this.$store.commit('user/updateVipInfo', response.data.isVIP)
              if (response.data.isVIP) {
                this.$router.replace({
                  name: 'home',
                  query: {
                    province_id: 20
                  }
                })
              } else if (window.previousRouter && window.previousRouter.name) {
                history.back()
              } else {
                this.$router.replace({
                  name: 'home'
                })
              }
            }
          })
        } else {
          alert(data.user_msg || '验证失败')
        }
      }
      )
    }
  }
}
</script>
<style lang="less">
.login{
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: url(//img.yimutian.com/crm/5bcc2fd46ef1433be54b5ebe45d5c2b2.jpeg) no-repeat center center;
  background-size: cover;
  overflow: auto;
}
.login_info{
  width: 350px;
  margin: 0 auto;
  .login_info_header{
    padding-top: 90px;
    .tianji{
      width: 100%;
    }
    font-size: 50px;
    color: #FFFFFF;
    text-align: center;
  }
  .innput_zone{
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;
    margin-top: 16px;
    background: #FFFFFF;
    border: 1px solid #E2E2E2;
    width: 100%;
    .title{
      font-size: 26px;
      color: #333333;
      text-align: center;
      height: 56px;
      line-height: 56px;
    }
    .phone_input{
      height: 50px;
      line-height: 50px;
      padding: 0 16px;
      font-size: 13px;
      color: #999999;
      background: #FFFFFF;
      border: 1px solid #E2E2E2;
    }
    .sendsms_btn{
      background-color: #005582;
      color: #fff;
      height: 50px;
      line-height: 50px;
      width: 109px;
      text-align: center;
      font-size: 13px;
      border: none;
      outline: none;
    }
    .input_row{
      position: relative;
      left: 0;
      top: 0;
      margin-bottom: 8px;
      overflow: hidden;
    }
    .ok_btn{
      font-size: 24px;
      color: #FFFFFF;
      text-align: center;
      height: 50px;
      line-height: 50px;
      background: #005582;
      margin-top: 16px;
      display: block;
      width: 100%;
      box-sizing: border-box;
      border: none;
      margin-bottom: 20px;
    }
  }
}
.img_code{
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  width: 130px;
  height: 50px;
}
</style>
